import { render, staticRenderFns } from "./Noise.vue?vue&type=template&id=4d88f77a&"
import script from "./Noise.vue?vue&type=script&lang=ts&"
export * from "./Noise.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports